/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAgentForm,
  CreateAgentForm$Outbound,
  CreateAgentForm$outboundSchema,
} from "../components/createagentform.js";

export type CreateAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createAgentForm: CreateAgentForm;
};

/** @internal */
export type CreateAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAgentSecurity$outboundSchema: z.ZodMiniType<
  CreateAgentSecurity$Outbound,
  CreateAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAgentSecurityToJSON(
  createAgentSecurity: CreateAgentSecurity,
): string {
  return JSON.stringify(
    CreateAgentSecurity$outboundSchema.parse(createAgentSecurity),
  );
}

/** @internal */
export type CreateAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateAgentForm: CreateAgentForm$Outbound;
};

/** @internal */
export const CreateAgentRequest$outboundSchema: z.ZodMiniType<
  CreateAgentRequest$Outbound,
  CreateAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createAgentForm: CreateAgentForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createAgentForm: "CreateAgentForm",
    });
  }),
);

export function createAgentRequestToJSON(
  createAgentRequest: CreateAgentRequest,
): string {
  return JSON.stringify(
    CreateAgentRequest$outboundSchema.parse(createAgentRequest),
  );
}
